import { Pipe, PipeTransform } from '@angular/core';
import { NumberFormatter } from '../tools/number-formatter';

@Pipe({
  name: 'numberFormat',
  standalone: true
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    return NumberFormatter.formatWithCommas(value);
  }
}
